export { getSnapdocsClosingAction, SNAPDOCS_CLOSING_ACTION_TYPE } from './snapdocsClosing.actions';
